import { render, staticRenderFns } from "./CompareInfo.vue?vue&type=template&id=44187b33&scoped=true&"
import script from "./CompareInfo.vue?vue&type=script&lang=js&"
export * from "./CompareInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompareInfo.vue?vue&type=style&index=0&id=44187b33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44187b33",
  null
  
)

export default component.exports